import { storeToRefs } from 'pinia'
import { useTeamsStore } from '@/stores/teams'

/**
 * Composable wrapper that returns Pinia state as proper reactive refs
 * (via storeToRefs) so destructuring works correctly in script setup.
 */
export function useTeams() {
  const store = useTeamsStore()
  const { teams, loading, error, pulling, lastPullSummaries } = storeToRefs(store)
  return {
    teams,
    loading,
    error,
    pulling,
    lastPullSummaries,
    refresh: store.refresh,
    create: store.create,
    createWithSubteam: store.createWithSubteam,
    patch: store.patch,
    remove: store.remove,
    pullNow: store.pullNow,
    addMember: store.addMember,
    patchMember: store.patchMember,
    removeMember: store.removeMember,
  }
}
